import React, { ReactElement, useEffect, useState } from "react";

type ZeeroCheckType = {
  id: string;
  text?: string;
  enabled?: boolean;
  title?: string;
  checked?: boolean;
  onChange: (checked: boolean) => void;
  classes?: string[];
};

export default function ZeeroCheck({
  id,
  text,
  title,
  enabled = true,
  checked,
  onChange,
  classes,
}: ZeeroCheckType): ReactElement {
  const [checkState, setCheckState] = useState(checked || false);

  useEffect(() => {
    setCheckState(checked || false);
  }, []);

  useEffect(() => {
    setCheckState(checked || false);
  }, [checked]);
  return (
    <div
      id={`${id}_container`}
      className={`zeero-check-container ${classes ? classes.join(" ") : ""} ${enabled == false ? "disabled" : ""}`}
      onClick={(evt) => {
        evt.stopPropagation();
        if (enabled) {
          const newState = !checkState;
          setCheckState(newState);
          onChange(newState);
        }
      }}
      onWheel={(event) => {event.stopPropagation()}}
    >
      <input
        id={`${id}_input`}
        className="zeero-check-input"
        type="checkbox"
        readOnly={enabled == false}
        title={title && title != "" ? title : text}
        checked={checkState}
		onClick={(e) => e.stopPropagation()}
        onChange={(evt) => {
          evt.stopPropagation();
          if (enabled) {
            setCheckState((evt.target as HTMLInputElement).checked);
            onChange((evt.target as HTMLInputElement).checked);
          }
        }}
      />
      {text && text != "" && <label className="zeero-check-input">{text}</label>}
    </div>
  );
}
